/* eslint-disable import/prefer-default-export */
export const TOGGLE_SHOW_MODAL_LOGS = 'TOGGLE_SHOW_MODAL_LOGS';
export const LAST_HOVER_PROJECT = 'LAST_HOVER_PROJECT';
